import axios from 'axios';
import moment from 'moment-timezone';
import { getToken, logoutAndRedirect } from './auth';
import { getStorage } from './storage';

const client = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000/api/misgav/',
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json'
  }
});

// Add interceptors
client.interceptors.request.use((config) => {
  const token = getToken();
  const locale = getStorage('locale') || 'en';
  const timezone = moment.tz.guess();

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
    config.headers['Content-Timezone'] = timezone;
  }
  config.headers['Content-Language'] = locale;
  config.headers['Accept-Language'] = locale;
  window.dispatchEvent(new CustomEvent('app:loader', { detail: true }));
  config.params = {
    ...config.params,
    setLocale: locale
  };
  return config;
}, error => Promise.reject(error));

client.interceptors.response.use(
  response => {
    window.dispatchEvent(new CustomEvent('app:loader', { detail: false }));
    return response.data
  },
  error => {
    window.dispatchEvent(new CustomEvent('app:loader', { detail: false }));
    if (error.response?.status === 401) {
      logoutAndRedirect('/access-denied');
      return;
    }
    return Promise.reject(error.response || error.message);
  }
);

/**
 * Usage: await http.get('/user');
 */
export const http = {
  get: (url, config = {}) => client.get(url, config),
  post: (url, data, config = {}) => client.post(url, data, config),
  put: (url, data, config = {}) => client.put(url, data, config),
  delete: (url, config = {}) => client.delete(url, config),
  patch: (url, data, config = {}) => client.patch(url, data, config),
  raw: client
};